export default () => {
    const wysiwygBlocks = document.querySelectorAll('.wysiwyg');

    for (const el of wysiwygBlocks) {
        const figures = el.querySelectorAll('figure');

        for (const figure of figures) {
            if (figure.nextElementSibling && figure.nextElementSibling.tagName === 'BR') {
                figure.nextElementSibling.remove();
            }
        }
    }
};
